/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */

import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { Button, Checkbox, Divider, IconButton, Stack, Typography, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { useEffect, useRef, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import 'react-phone-input-2/lib/material.css'
import { useAppDispatch, useAppSelector } from '../../_helpers/hooks'
import { ISlotsFormData } from '../../_models/commonInterface'
import { IFacility } from '../../_models/facilityInterface'
import {
  IBlockSeats,
  IFloorsNewBooking,
  INewBookingLocations,
  IPhoneDetails,
  ISeatInFloors,
  ISeats,
  ISlotInfo,
} from '../../_models/newBookingInterface'

import {
  facilityState,
  getLocationFacilities,
  resetFacilityDropdown,
} from '../../slices/facilitySlice'
import {
  blockSeats,
  changeValue,
  checkFloorsAndUpdateSeatDetails,
  checkForFloors,
  closeDrawer,
  getCSVSeatsInFloors,
  getFloors,
  getSVGSeatsInFloors,
  getSlots,
  newBooking,
  newBookingData,
  resetBookingDetails,
  resetFloorDetails,
  resetSeatAvailabilityStates,
  setSelectedFloor,
  setSelectedSlot,
  unBlockSeats,
  updateBooking,
  updateBookingConfirmationModalStatus,
  updateFloorDetails,
  updateIsBookForOthers,
  updateNotBlockedSeats,
  updatePreviouslyBlockedSeats,
  updateSelectedSeats,
  validateEmails,
} from '../../slices/newBookingSlice'

import { InfoOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { PERMISSIONS } from '../../_constants'
import { dateToYearMonthDay, stampToTime } from '../../_helpers/dateTime'
import { handleMessages } from '../../_helpers/utilities'
import { ILocationsFromActiveToken } from '../../_models/bookingManagementInterface'
import CustomDrawer from '../../components/@extended/customDrawer'
import {
  PageDrawerContainer,
  PageDrawerFooterButtonsContainer,
  PageDrawerHeaderContainer,
  PageDrawerSectionContainer,
} from '../../components/containers/pageDrawerContainers'
import { WarningIcon } from '../../components/icons'
import { GridSkeleton } from '../../components/loader'
import '../../components/phoneInput/phoneInput.scss'
import LightTooltip from '../../components/toolTip'
import { useUserPermissionAuthorization } from '../../hooks'
import { bookingManagementState } from '../../slices/bookingManagementSlice'
import { errorToast } from '../../slices/toastSlice'
import { userState } from '../../slices/userSlice'
import { voyagerState } from '../../slices/voyagerSlice'
import ActionAlertModal from '../actionAlertModal'
import BookingConfirmationModal from '../bookingConfirmationModal'
import BookingSuccessModal from '../bookingSuccessModal'
import BookForOthersFormFields from './bookForOthersEmail'
import SelectedSlot from './bookingSlots/selectedSlot'
import Slots from './bookingSlots/slots'
import Counters from './counters'
import DateSelection from './dateSelection'
import FormFields from './formFields'
import { useSubmitButtonText } from './helpers'
import SeatSelectionArea from './seatSelectionArea'
interface IDrawer {
  drawerStatus: boolean
  updateDrawer: () => void
}

const NewBookingDrawer = (props: IDrawer) => {
  type FormInputs = {
    email: string | null
    name: string | null
    phone: string | null
    location: INewBookingLocations | null
    facility: IFacility | null
  }
  type FormFields = {
    email: string
    name: string
    phone: string
    location: INewBookingLocations | null
    facility: IFacility | null
  }

  const formFields = useForm<FormFields>({
    mode: 'onChange',
  })
  const {
    formState: { isSubmitted },
    handleSubmit,
  } = formFields

  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const [showErrorData, setShowErrorData] = useState<string>('')
  const [showDiscardAlert, setShowDiscardAlert] = useState(false)
  const [bookForOthersUnChecked, setBookForOthersUnChecked] = useState(false)
  const { businessConfig } = useAppSelector(voyagerState)
  const newBookingState = useAppSelector(newBookingData)
  const facilityData = useAppSelector(facilityState)
  const bookingManagementData = useAppSelector(bookingManagementState)
  const { userData } = useAppSelector(userState)
  const { facilitiesAndLocationsFromActiveToken } = bookingManagementData
  const { bookingFacilities } = facilityData
  const {
    newBookingLocationInformation,
    phoneNumberInformation,
    slotInformation,
    slotInformationMessage,
    bookingDetails,
    drawerType,
    bookingSuccessModalStatus,
    bookingConfirmationModalStatus,
    isLoadingSlots,
    noActiveToken,
    seatAvailable,
    floorDetails,
    selectedSeats,
    previouslyBlockedSeats,
    notBlockedSeats,
    floors,
    floorNotAvailable,
    isBookForOthers,
    bookingSuccessInformation,
  } = newBookingState

  const theme = useTheme()
  const slotInfoMorning = slotInformation?.slots_morning
  const slotInfoAfternoon = slotInformation?.slots_afternoon
  const slotInfoEvening = slotInformation?.slots_evening
  const slotInfoNight = slotInformation?.slots_night
  const [state, setState] = useState<boolean>()
  const facilityId = formFields?.getValues('facility')?.id_hash
  const [date, setDate] = useState<string>('')
  const [phoneDetails, setPhoneDetails] = useState<IPhoneDetails>()
  const [numberUpdated, setNumberUpdated] = useState<boolean>(false)
  const [seatCount, setSeatCount] = useState(1)
  const [slotInfo, setSlotInfo] = useState<ISlotInfo>({})
  const { slotId, slotTime } = slotInfo
  const slotAvailabilityError =
    !slotInfoMorning && !slotInfoAfternoon && !slotInfoEvening && !slotInfoNight
  const [counterError, setCounterError] = useState(false)
  const [slotAvailability, setSlotAvailability] = useState(0)
  const [floor, setFloor] = useState<IFloorsNewBooking | null>(null)
  const [isSeatMandatory, setIsSeatMandatory] = useState(false)
  const [displaySeatSelection, setDisplaySeatSelection] = useState(false)

  const [drawerWidth, setDrawerWidth] = useState({
    xl: '50%',
    md: '59.938rem',
    breakpoint: '55%',
  })
  const [isExpanded, setIsExpanded] = useState(false)
  const [isEditFloorInfoLoaded, setIsEditFloorInfoLoaded] = useState<boolean>(false)
  const seatSelectionContainerRef = useRef<HTMLDivElement | null>(null)
  const svgSeatSelectionRef = useRef(null)
  const [displaySlots, setDisplaySlots] = useState(false)
  const [userEmails, setUserEmails] = useState<string[]>([])
  const [isPermitted] = useUserPermissionAuthorization()
  const isPermissionForKpi = isPermitted([PERMISSIONS.DASHBOARD_KPI_VIEW])
  const submitButtonText = useSubmitButtonText(drawerType, displaySeatSelection, isSeatMandatory)

  const handleCloseSvgBookingPopup = () => {
    if (svgSeatSelectionRef?.current) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const currentRef = svgSeatSelectionRef.current as any
      currentRef.handleClose()
    }
  }
  useEffect(() => {
    setState(props.drawerStatus)
    dispatch(updateIsBookForOthers(false))
  }, [props.drawerStatus])
  useEffect(() => {
    const handleBackButton = () => {
      dispatch(closeDrawer())
    }
    window.addEventListener('popstate', handleBackButton)
    return () => {
      window.removeEventListener('popstate', handleBackButton)
    }
  }, [])

  useEffect(() => {
    if (bookingDetails && drawerType === 'edit') {
      handleEditBooking()
    } else if (drawerType === 'create') {
      handleCreateBooking()
    }
  }, [bookingDetails, drawerType])
  useEffect(() => {
    // set location value in edit flow
    if (bookingDetails && drawerType === 'edit') {
      const locationVal = newBookingLocationInformation?.find(
        (location: INewBookingLocations) => location.id === bookingDetails?.location_id,
      )
      if (locationVal) formFields.setValue('location', locationVal)
    }
  }, [newBookingLocationInformation, bookingDetails])

  useEffect(() => {
    // set facility value in edit flow
    if (bookingDetails && drawerType === 'edit') {
      const facilityVal = bookingFacilities?.find(
        (facility: IFacility) => facility?.id_hash == bookingDetails?.facility_id,
      )
      if (facilityVal) formFields?.setValue('facility', facilityVal)
    }
  }, [bookingFacilities])
  useEffect(() => {
    if (date) callSlotsApi()
  }, [date])
  useEffect(() => {
    // populate location and facility in booking form from booking management
    if (noActiveToken) {
      const activeTokenLocations = facilitiesAndLocationsFromActiveToken?.locations
      if (activeTokenLocations) {
        const locationVal = activeTokenLocations?.find(
          (location: ILocationsFromActiveToken) => location?.is_selected == 1,
        )
        if (locationVal) {
          formFields?.setValue('location', locationVal)
          dispatch(getLocationFacilities(locationVal?.id))
        }
      }
      const activeTokenFacilities = facilitiesAndLocationsFromActiveToken?.facilities
      if (activeTokenFacilities) {
        const facilityVal = activeTokenFacilities?.find(
          (facility: IFacility) => facility.is_selected == 1,
        )
        if (facilityVal) formFields?.setValue('facility', facilityVal)
      }
    }
  }, [facilitiesAndLocationsFromActiveToken])

  const handleEditBooking = () => {
    if (newBookingLocationInformation) {
      dispatch(getLocationFacilities(bookingDetails?.location_id))
      const phoneData = bookingDetails?.user_country_code + bookingDetails?.user_phone
      formFields?.setValue('email', bookingDetails?.user_email)
      formFields?.setValue('name', bookingDetails?.user_name)
      formFields?.setValue('phone', phoneData)
      updatePhoneDetails(
        bookingDetails?.user_country_code,
        bookingDetails?.user_phone,
        bookingDetails?.user_iso_code,
      )
      setSeatCount(bookingDetails?.no_of_seats)
      setDate(bookingDetails?.date)
      setDisplaySlots(true)
      setSlotAvailability(bookingDetails?.number_of_available_slots)
      setSlotInfo((prevState) => ({
        ...prevState,
        slotId: bookingDetails?.master_slot_id,
        slotTime: `${stampToTime(bookingDetails?.preferred_slot_from)} - ${stampToTime(
          bookingDetails?.preferred_slot_to,
        )}`,
      }))
      // get floor and seat details
      if (bookingDetails?.master_slot_id && bookingDetails?.facility_id && bookingDetails?.date) {
        dispatch(checkFloorsAndUpdateSeatDetails(bookingDetails))
      }
      if (bookingDetails?.map_details && drawerType === 'edit') {
        setIsSeatMandatory(true)
      } else {
        setIsSeatMandatory(false)
      }
    }
  }
  const handleCreateBooking = () => {
    if (noActiveToken) {
      // handle date as today's date in booking management
      setDate(dateToYearMonthDay(new Date().toString()))
      formFields?.setValue('email', '')
    } else {
      resetAllValues()
      resetFormValues()
      dispatch(resetBookingDetails())
    }
    dispatch(resetFacilityDropdown())
  }

  // set floor and need seat selection local states based on booking details
  useEffect(() => {
    if (floors?.length > 0 && drawerType === 'edit') {
      // seats were already chosen in floor with seats and seatsAvailable
      if (
        bookingDetails?.floor &&
        seatAvailable &&
        isEditFloorInfoLoaded === false &&
        bookingDetails?.map_details
      ) {
        setIsSeatMandatory(true)

        const bookedFloor = floors.find(
          (floor: IFloorsNewBooking) => floor.floor_name === bookingDetails?.floor,
        )
        // set booked floor details
        if (bookedFloor && bookingDetails?.facility_id && bookingDetails?.master_slot_id) {
          setFloor(bookedFloor)
        }
        setIsEditFloorInfoLoaded(true)
      }

      if (!seatAvailable || !bookingDetails?.floor || !bookingDetails?.map_details) {
        setIsSeatMandatory(false)
      }
    }
  }, [floors])

  const closeDiscardAlertModal = () => {
    setShowDiscardAlert(false)
  }

  const toggleDrawer = () => () => {
    if (userEmails?.length > 0) {
      setShowDiscardAlert(true)
    } else {
      closeBookingDrawer()
      setShowDiscardAlert(false)
    }
  }

  const updatePhoneDetails = (
    countryCodeData: string,
    phoneNumberData: string,
    isoCode: string,
  ) => {
    const phoneDetails: IPhoneDetails = {
      countryCode: countryCodeData,
      phoneNumber: phoneNumberData,
      isoCode: isoCode,
    }
    if (phoneDetails) {
      setPhoneDetails(phoneDetails)
    }
    setNumberUpdated(true)
  }
  const onLocationChange = (locationId: number) => {
    resetDateSlotsCounterSeatValues()
    dispatch(getLocationFacilities(locationId))
    dispatch(resetSeatAvailabilityStates())
  }
  const onFacilityChange = () => {
    resetDateSlotsCounterSeatValues()
  }
  const onDateChange = () => {
    resetSelectedSeatsAndFloors()
    setSlotInfo((prevState) => ({
      ...prevState,
      slotId: undefined,
    }))
  }
  const onCountersChange = () => {
    // event of seat number changed
  }
  const callSlotsApi = () => {
    const slotsFormData: ISlotsFormData = {
      business_unit_id: facilityId,
      schedule_date: date,
      token: bookingDetails?.token_id ? bookingDetails?.token_id : null,
      no_of_seats: seatCount,
    }
    if (slotsFormData.business_unit_id && date) {
      dispatch(getSlots(slotsFormData))
      setDisplaySlots(true)
    }
  }
  const onSlotSelection = (slot: number | undefined) => {
    resetSelectedSeatsAndFloors()
    dispatch(setSelectedSlot(slot))
    if (facilityId && slot && date) {
      const getFloorsParams = {
        facility_id: facilityId,
        master_slot_id: slot,
        date: date,
      }
      dispatch(
        checkForFloors(
          drawerType === 'edit'
            ? { ...getFloorsParams, token_id: bookingDetails?.token_id }
            : getFloorsParams,
        ),
      )
    }
  }
  const onSlotDeselect = () => {
    setSlotInfo((prevState) => ({
      ...prevState,
      slotId: undefined,
    }))
    resetSelectedSeatsAndFloors()
    resetCounter()
    callSlotsApi()
  }

  const closeBookingDrawer = (): void => {
    dispatch(setSelectedSlot(null))
    dispatch(setSelectedFloor(null))
    dispatch(updateIsBookForOthers(false))
    unBlockedSeats()
    resetAllValues()
    setShowDiscardAlert(false)
    props.updateDrawer()
  }
  const resetAllValues = () => {
    dispatch(changeValue({ isDuplicatePhoneNumber: false }))
    setShowErrorData('')

    formFields.reset()
    resetDateSlotsCounterSeatValues()
    setIsEditFloorInfoLoaded(false)
    dispatch(resetFacilityDropdown())
    setUserEmails([])
    setDisplaySeatSelection(false)
    resetFormValues()
    dispatch(resetSeatAvailabilityStates())
  }
  const resetFormValues = () => {
    formFields?.setValue('email', '')
    formFields?.setValue('phone', '1')
    formFields?.setValue('name', '')
    formFields?.setValue('location', null)
    formFields?.setValue('facility', null)
  }
  const resetDateSlotsCounterSeatValues = () => {
    resetSelectedSeatsAndFloors()
    setDate('')
    setSlotInfo((prevState) => ({
      ...prevState,
      slotId: undefined,
    }))
    resetCounter()
    dispatch(updateNotBlockedSeats([]))
    dispatch(updatePreviouslyBlockedSeats([]))
    setDisplaySlots(false)
  }
  const resetCounter = () => {
    setSeatCount(1)
    setSlotAvailability(0)
  }
  const isValidData = () => {
    return date && slotId && !counterError && !showErrorData
  }
  const handleBookingConfirmationStatus = (bookingConfirmationStatus: string) => {
    const formData = {
      email: formFields?.getValues().email,
      name: formFields?.getValues().name,
      country_code: numberUpdated
        ? phoneDetails?.countryCode
        : phoneNumberInformation?.country_code,
      phone: numberUpdated ? phoneDetails?.phoneNumber : phoneNumberInformation?.phone,
      iso_code: numberUpdated ? phoneDetails?.isoCode : phoneNumberInformation?.iso_code,
      facility_id: formFields?.getValues().facility?.id_hash,
      no_of_seats: seatCount,
      date: date,
      master_slot_id: slotId,
      book_for_others: isBookForOthers,
      customer_info:
        selectedSeats?.length > 0 && isBookForOthers
          ? userEmails?.map((email) => ({
              seat_id: selectedSeats?.find((seat) => seat?.user_email === email)?.seat_id || null,
              user_email: email,
            }))
          : selectedSeats?.length > 0
          ? selectedSeats?.map((seat) => ({
              seat_id: seat?.seat_id,
              user_email: seat?.user_email,
            }))
          : isBookForOthers
          ? userEmails?.map((email) => ({
              seat_id: null,
              user_email: email,
            }))
          : [{}],
      floor_id: selectedSeats?.length > 0 ? floor?.floor_id : null,
    }

    if (isBookForOthers && drawerType === 'create') {
      // added for supporting backend validations
      formData.email = userData.email ? userData.email : ''
      formData.phone = userData.phone
      formData.country_code = userData.country_code
    }
    switch (bookingConfirmationStatus) {
      case 'Confirm':
        dispatch(updateBookingConfirmationModalStatus(false))
        if (drawerType === 'create' && isValidData()) {
          if (phoneNumberInformation?.user_is_random_phone) {
            delete formData?.country_code
            delete formData?.phone
          }

          dispatch(newBooking(formData))
        }
        if (drawerType === 'edit' && isValidData()) {
          const editFormData = {
            ...formData,
            token_id: bookingDetails?.token_id,
            seat_list: selectedSeats.map((seat: ISeats) => seat.seat_id),
          }
          if (bookingDetails?.is_random_phone) {
            delete editFormData?.country_code
            delete editFormData?.phone
            delete editFormData?.iso_code
          }

          dispatch(
            updateBooking({ formData: editFormData, isPermissionForKpi: isPermissionForKpi }),
          )
        }
        break

      case 'Cancel':
        dispatch(updateBookingConfirmationModalStatus(false))
        break

      case 'Discard':
        dispatch(updateBookingConfirmationModalStatus(false))
        closeBookingDrawer()
        break

      default:
        break
    }
  }

  const onSubmit: SubmitHandler<FormInputs> = () => {
    formFields?.trigger()
    if (!isValidData()) return

    //  Must add at least one email when booking for others
    if (drawerType === 'create' && isBookForOthers && userEmails?.length <= 0) {
      dispatch(errorToast(handleMessages(t('newBooking.addAtleastOneVisitorEmailToast'))))
      return
    }
    // floor and seat selection is mandatory
    if (displaySeatSelection) {
      if (!floor) {
        dispatch(errorToast(handleMessages(t('newBooking.selectFloorValidation'))))
        return
      }
      if (!selectedSeats?.length) {
        dispatch(errorToast(handleMessages(t('newBooking.selectSeatValidation'))))
        return
      }
    }

    // if the facility has seat selection
    if (isSeatMandatory && !displaySeatSelection) {
      showSeatSelection()
      return
    }

    // seat selection is not mandatory
    if (!displaySeatSelection) {
      if (isBookForOthers) {
        dispatch(validateEmails({ user_emails: userEmails }))
      } else {
        dispatch(updateBookingConfirmationModalStatus(true))
      }
      return
    }

    // seat selection is mandatory
    else if (selectedSeats?.length > 0 || previouslyBlockedSeats?.length > 0) {
      //  show error if selected seats are not equal to seat count
      if (selectedSeats?.length !== seatCount) {
        dispatch(
          errorToast(
            handleMessages(
              isBookForOthers
                ? t('newBooking.assignSeatsToAllVisitors')
                : t('newBooking.seatCountNotEqualToSelectedSeats'),
            ),
          ),
        )
        return
      }
      const blockSeatParams: IBlockSeats = {
        floor_id: floor?.floor_id,
        facility_id: facilityId,
        master_slot_id: slotId,
        date: date,
        no_of_seats: seatCount,
        customer_info: [],
      }
      dispatch(updateNotBlockedSeats([]))

      if (selectedSeats?.length > 0) {
        blockSeatParams.customer_info = selectedSeats.map((seat: ISeats) => ({
          seat_id: seat.seat_id,
          user_email: seat.user_email || '',
        }))
      }

      if (previouslyBlockedSeats?.length > 0) {
        blockSeatParams.previously_blocked_seats = previouslyBlockedSeats
      }

      if (drawerType === 'create') {
        if (isBookForOthers) {
          blockSeatParams.isBookForOthers = true
          blockSeatParams.userEmails = userEmails
        }
        dispatch(blockSeats(blockSeatParams))
      } else {
        dispatch(blockSeats({ ...blockSeatParams, token_id: bookingDetails?.token_id }))
      }
    }
  }

  const handleUpdateDrawerWidth = (expand: boolean) => {
    setIsExpanded(expand)
    if (expand) {
      setDrawerWidth({
        xl: '90%',
        md: '90%',
        breakpoint: '90%',
      })
    } else {
      setDrawerWidth({
        xl: '50%',
        md: '59.938rem',
        breakpoint: '55%',
      })
    }
  }
  useEffect(() => {
    if (notBlockedSeats?.length > 0 && floor !== null) {
      dispatch(resetFloorDetails)
      const getSeatParam: ISeatInFloors = {
        floor_id: floor.floor_id,
        facility_id: facilityId,
        master_slot_id: slotId,
        date: date,
        no_of_seats: seatCount,
      }
      if (floor.floor_type === 1) {
        dispatch(getSVGSeatsInFloors(getSeatParam))
      } else {
        dispatch(getCSVSeatsInFloors(getSeatParam))
      }
    }
  }, [notBlockedSeats])

  useEffect(() => {
    if (notBlockedSeats?.length > 0) {
      const updatedSelectedSeats = selectedSeats.filter(
        (seat) =>
          !notBlockedSeats.some((notBlockedSeat) => notBlockedSeat.seat_id === seat.seat_id),
      )

      if (updatedSelectedSeats?.length > 0) {
        // Check if there is a match between floorDetails.seats and selectedSeats with a different status
        const hasMatch = floorDetails.seats.some((seat) =>
          updatedSelectedSeats.some(
            (selectedSeat) =>
              selectedSeat.seat_id === seat.seat_id && selectedSeat.status !== seat.status,
          ),
        )
        if (hasMatch) {
          const updatedFloorDetails = {
            ...floorDetails,
            seats: floorDetails.seats.map((seat: ISeats) => {
              // Check if the seat_id exists in selectedSeats
              if (
                updatedSelectedSeats.some((selectedSeat) => selectedSeat.seat_id === seat.seat_id)
              ) {
                // If the seat_id exists in selectedSeats, update the status to 1
                return { ...seat, status: 1 }
              } else {
                // If not found in selectedSeats, return the original seat object
                return seat
              }
            }),

            availableSeats: floorDetails.availableSeats + updatedSelectedSeats?.length,
          }

          // Dispatch the updatedFloorDetails
          dispatch(updateFloorDetails(updatedFloorDetails))
          dispatch(updateNotBlockedSeats([]))
        }
      }
      dispatch(updateSelectedSeats(updatedSelectedSeats))
    }
  }, [floorDetails])

  useEffect(() => {
    if (seatAvailable == 1) setIsSeatMandatory(true)
    else setIsSeatMandatory(false)
  }, [seatAvailable])

  useEffect(() => {
    if (isSeatMandatory && isExpanded) handleUpdateDrawerWidth(true)
    else handleUpdateDrawerWidth(false)
  }, [isSeatMandatory])

  useEffect(() => {
    if (
      (isExpanded || floorDetails.seats?.length > 0 || displaySeatSelection) &&
      seatSelectionContainerRef.current
    ) {
      const drawerPaper = seatSelectionContainerRef.current.closest('.MuiDrawer-paper')
      if (drawerPaper) {
        drawerPaper.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }, [isExpanded, floorDetails, displaySeatSelection])

  const handleFloorSelectionChange = (floor: IFloorsNewBooking | null) => {
    dispatch(setSelectedFloor(floor?.floor_id))
    unBlockedSeats()
    dispatch(resetFloorDetails())
    setFloor(floor)
    dispatch(updateSelectedSeats([]))
    dispatch(updateNotBlockedSeats([]))
    dispatch(updatePreviouslyBlockedSeats([]))

    if (floor) {
      const getSeatParam: ISeatInFloors = {
        floor_id: floor.floor_id,
        facility_id: facilityId,
        master_slot_id: slotId,
        date: date,
        no_of_seats: seatCount,
      }
      if (floor.floor_type === 1) {
        dispatch(getSVGSeatsInFloors(getSeatParam))
      } else {
        dispatch(getCSVSeatsInFloors(getSeatParam))
      }
    }
  }

  // reset selected seats, selected floor details and floors list
  const resetSelectedSeatsAndFloors = () => {
    unBlockedSeats()
    dispatch(resetFloorDetails())
    dispatch(updateSelectedSeats([]))
    setFloor(null)
    dispatch(changeValue({ floors: [] }))
    setUserEmails([])
  }
  useEffect(() => {
    if (floorNotAvailable) {
      resetSelectedSeatsAndFloors()
      const getFloorsParams = {
        facility_id: facilityId as string,
        master_slot_id: slotId as number,
        date: date as string,
      }
      dispatch(getFloors(getFloorsParams))
    }
  }, [floorNotAvailable])
  useEffect(() => {
    if (!props.drawerStatus) {
      resetAllValues()
    }
  }, [props.drawerStatus])
  const unBlockedSeats = () => {
    if (date && !counterError && slotId && floor && previouslyBlockedSeats?.length > 0) {
      const blockSeatPrams: IBlockSeats = {
        floor_id: floor?.floor_id,
        facility_id: facilityId,
        master_slot_id: slotId,
        date: date,
        no_of_seats: seatCount,
        customer_info: [],
        previously_blocked_seats: previouslyBlockedSeats,
      }
      dispatch(unBlockSeats(blockSeatPrams))
    }
  }

  // book for others
  const handleBookForOthers = (event: { target: { checked: boolean } }) => {
    if (event.target.checked) {
      dispatch(updateIsBookForOthers(true))
    } else {
      setBookForOthersUnChecked(true)

      if (userEmails?.length > 0) {
        setShowDiscardAlert(true)
      } else {
        dispatch(updateIsBookForOthers(false))
        resetAllValues()
      }
    }
  }
  const alertConfirm = () => {
    if (isBookForOthers && !bookForOthersUnChecked) {
      closeBookingDrawer()
    } else if (isBookForOthers && bookForOthersUnChecked) {
      setShowDiscardAlert(false)
      dispatch(updateIsBookForOthers(false))
      resetAllValues()
    }
  }
  const handleAddUserEmailButton = (emailValue: string) => {
    if (Math.min(slotAvailability, businessConfig.max_bulk_bookings) > userEmails?.length) {
      if (!userEmails.includes(emailValue)) {
        setUserEmails((prevUserEmails) => [...prevUserEmails, emailValue])
      } else {
        dispatch(errorToast(handleMessages(t('newBooking.emailAlreadyAddedError'))))
      }
    } else {
      dispatch(errorToast(handleMessages(t('newBooking.visitorSlotLimitError'))))
    }
  }
  const handleEmailClearClick = (emailToRemove: string) => {
    // Check if the userEmails array contains the email to remove
    if (userEmails.includes(emailToRemove)) {
      if (selectedSeats?.length > 0) {
        // Filter out the seat with the specified emailToRemove
        const updatedSelectedSeats = selectedSeats.filter(
          (seat) => seat.user_email !== emailToRemove,
        )
        // Update the selectedSeats state with the filtered array
        dispatch(updateSelectedSeats(updatedSelectedSeats))
      }
      // Filter out the email to remove from the userEmails array
      const updatedEmails = userEmails.filter((email) => email !== emailToRemove)

      // Update the userEmails state with the filtered array
      setUserEmails(updatedEmails)
    }
  }
  useEffect(() => {
    if (isBookForOthers) {
      setSeatCount(userEmails?.length > 0 ? userEmails?.length : 1)
      handleFloorSelectionChange(null) // reset the floor selection
    }
  }, [userEmails?.length])

  const showSeatSelection = () => {
    const status =
      facilityId &&
      date &&
      slotId &&
      isSeatMandatory &&
      (!isBookForOthers || userEmails?.length > 0)

    if (status) setDisplaySeatSelection(true)
    else setDisplaySeatSelection(false)
  }

  const counterProps = {
    seatCount,
    setSeatCount,
    onCountersChange,
    setCounterError,
    slotAvailability,
  }
  // disable counter if slot is not selected
  const handleDisableCounter = () => {
    if (slotId) return false
    else return true
  }
  return (
    <>
      <CustomDrawer
        drawerStatus={Boolean(state)}
        handleClose={toggleDrawer()}
        handleScrollCapture={handleCloseSvgBookingPopup}
        sx={{
          zIndex: 1000,
          '& .MuiDrawer-paper': {
            width: { xs: '100%', sm: '100%', md: drawerWidth.md, xl: drawerWidth.xl },
            pt: '4.75rem',
            [theme.breakpoints.up(1536)]: {
              width: drawerWidth.breakpoint,
            },
            [theme.breakpoints.up(1670)]: {
              width: drawerWidth.xl,
            },
          },
        }}
      >
        <form noValidate onSubmit={handleSubmit(onSubmit)}>
          <PageDrawerContainer>
            <PageDrawerSectionContainer>
              <PageDrawerHeaderContainer>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant='h4' sx={{ fontSize: '1.5rem' }} color='common.black'>
                    {drawerType === 'edit'
                      ? t('newBooking.editAppointmentTitle')
                      : t('newBooking.bookAnAppointmentTitle')}
                  </Typography>
                </Box>
                <IconButton onClick={toggleDrawer()} sx={{ p: 0 }}>
                  <CloseRoundedIcon />
                </IconButton>
              </PageDrawerHeaderContainer>

              <Box
                display={displaySeatSelection ? 'none' : 'block'}
                sx={(theme) => ({
                  minHeight: {
                    xs: 0,
                    sm: 600,
                    md: '68vh',
                  },
                  [theme.breakpoints.up(1568)]: {
                    minHeight: '71vh',
                  },
                })}
              >
                {drawerType !== 'edit' && isPermitted([PERMISSIONS.BOOK_FOR_OTHERS]) && (
                  <Box display={'flex'} mt={1}>
                    <Checkbox
                      checked={isBookForOthers}
                      color='primary'
                      onChange={handleBookForOthers}
                    />
                    <Typography variant='subtitle2' color='common.black' ml={0.1} mt={1}>
                      {t('newBooking.bookMultipleVisitorTitle')}
                    </Typography>
                    <LightTooltip title={t('newBooking.multipleVisitorInfo')} enterTouchDelay={0}>
                      <IconButton aria-label='' sx={{ ml: '0 !important' }}>
                        <InfoOutlined color='primary' fontSize='small' />
                      </IconButton>
                    </LightTooltip>
                  </Box>
                )}

                <FormFields
                  setShowErrorData={setShowErrorData}
                  showErrorData={showErrorData}
                  form={formFields}
                  isSubmitted={isSubmitted}
                  onLocationChange={onLocationChange}
                  onFacilityChange={onFacilityChange}
                  isExpanded={isExpanded}
                  updatePhoneDetails={updatePhoneDetails}
                  setNumberUpdated={setNumberUpdated}
                  isBookForOthers={isBookForOthers}
                  phoneDetails={phoneDetails}
                  setPhoneDetails={setPhoneDetails}
                />

                <DateSelection
                  date={date}
                  setDate={setDate}
                  isSubmitted={isSubmitted}
                  onDateChange={onDateChange}
                />

                {slotId ? (
                  <SelectedSlot slotInfo={slotInfo} onSlotDeselect={onSlotDeselect} />
                ) : (
                  <Box>
                    {isLoadingSlots ? (
                      <GridSkeleton
                        width={isExpanded ? '50%' : '100%'}
                        height={'2.75rem'}
                        count={8}
                        xs={6}
                        sm={3}
                        md={3}
                        lg={3}
                        xl={3}
                      />
                    ) : (
                      <Box
                        className='SlotsBox'
                        m={0}
                        p={0}
                        // display={isSeatMandatory ? 'none' : 'contents'}
                      >
                        {slotInformation && displaySlots && (
                          <Slots
                            onSlotSelection={onSlotSelection}
                            slotInfo={slotInfo}
                            setSlotInfo={setSlotInfo}
                            isDrawerExpanded={isExpanded}
                            setSlotAvailability={setSlotAvailability}
                          />
                        )}
                        {isSubmitted &&
                          date &&
                          !slotId &&
                          (slotInfoMorning?.length ||
                            slotInfoAfternoon?.length ||
                            slotInfoEvening?.length ||
                            slotInfoNight?.length) && (
                            <Typography variant='subtitle2' fontSize={14} ml={1.25} color='error'>
                              {t('newBooking.newBookingSlot')}
                            </Typography>
                          )}

                        {slotAvailabilityError && date && (
                          <Typography variant='subtitle2' fontSize={14} ml={1.25} color='error'>
                            {slotInformationMessage}
                          </Typography>
                        )}
                      </Box>
                    )}
                  </Box>
                )}
                {seatAvailable == 0 && !isBookForOthers && (
                  <Box mt={3}>
                    <Counters {...counterProps} disableCounter={handleDisableCounter()} />
                  </Box>
                )}

                {facilityId && date && slotId && isBookForOthers && (
                  <BookForOthersFormFields
                    isExpanded={isExpanded}
                    userEmails={userEmails}
                    handleAddUserEmailButton={handleAddUserEmailButton}
                    handleEmailClearClick={handleEmailClearClick}
                  />
                )}
              </Box>

              <Box display={displaySeatSelection ? 'block' : 'none'} mt={4}>
                <Box
                  ref={seatSelectionContainerRef}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100vh',
                  }}
                >
                  <SeatSelectionArea
                    svgSeatSelectionRef={svgSeatSelectionRef}
                    noOfSeat={seatCount}
                    handleFloorSelectionChange={handleFloorSelectionChange}
                    updateDrawerWidth={handleUpdateDrawerWidth}
                    selectedFloor={floor}
                    isBookForOthers={isBookForOthers}
                    userEmails={userEmails}
                    setDisplaySeatSelection={setDisplaySeatSelection}
                    slotInfo={slotInfo}
                    date={date}
                    {...counterProps}
                  />
                </Box>
              </Box>
            </PageDrawerSectionContainer>
            <Divider />
            <PageDrawerFooterButtonsContainer
              sx={{
                backgroundColor: 'white',
                position: 'sticky',
                bottom: 0,
                py: 2,
                px: 3,
                borderTop: `0.0625rem solid ${theme.palette.divider}`,
              }}
            >
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <Box>
                  <Button
                    type='submit'
                    variant='contained'
                    size='large'
                    sx={{ width: '100%', minWidth: '12.5rem', textTransform: 'none' }}
                  >
                    {submitButtonText}
                  </Button>
                </Box>
                <Box>
                  <Button
                    sx={{ width: '100%', minWidth: '12.5rem' }}
                    variant='outlined'
                    size='large'
                    onClick={toggleDrawer()}
                  >
                    {t('newBooking.cancelBtn')}
                  </Button>
                </Box>
              </Stack>
            </PageDrawerFooterButtonsContainer>
          </PageDrawerContainer>
        </form>
        <ActionAlertModal
          showAlert={showDiscardAlert}
          title={t('newBooking.discardChangesTitle')}
          isDefaultButtonsVisible={true}
          cancelButtonText={t('newBooking.noButton')}
          confirmButtonText={t('newBooking.yesBtn')}
          onAlertClose={closeDiscardAlertModal}
          onAlertConfirm={alertConfirm}
          alertIcon={
            <WarningIcon
              fill={theme.palette.iconColors.contrastText}
              width='46'
              height='46'
              stoke={theme.palette.common.white}
            />
          }
        >
          <Box p={'0.625rem'} minWidth={{ md: '30rem', xs: 0 }}>
            <Typography variant='subtitle1' color='secondary.main' textAlign='center'>
              {t('newBooking.settingsDiscardChangesMsg')}
            </Typography>

            <Typography variant='subtitle1' color='table.dark' mb={'1.375rem'} textAlign='center'>
              {''}
            </Typography>
          </Box>
        </ActionAlertModal>
      </CustomDrawer>
      <BookingSuccessModal
        showModal={bookingSuccessModalStatus && Object.keys(bookingSuccessInformation).length > 0}
        userType='admin'
      />
      {bookingConfirmationModalStatus && date && slotId && (
        <BookingConfirmationModal
          showModal={bookingConfirmationModalStatus}
          bookingInfo={{
            date: date,
            timeSlot: slotTime || '',
            noOfSeats: seatCount,
            floorName: floor ? floor.floor_name : '',
            selectedSeats: selectedSeats,
            facilityName: formFields?.getValues().facility?.name || '',
            selectedEmails: isBookForOthers
              ? userEmails
              : [formFields?.getValues().email as string],
          }}
          updateBookingConfirmationStatus={handleBookingConfirmationStatus}
        />
      )}
    </>
  )
}

export default NewBookingDrawer
